// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"907c1440","337":"571f02ba","667":"22678dbd"}[chunkId] + ".chunk.js";
};